module fdm.clientManagement {

    class ClientManagementDetailsController implements ng.IController {
        public clientData: any;
        public isLoading: boolean;
        public isUploadingLogo: boolean;
        public logoDisplayUrl: string;

        constructor(
            private restfullApiClientService: dg.restfulApi.RestfullApiClientService,
            private $scope: ng.IScope,
            private $http: ng.IHttpService,
            private apiSettings: dg.restfulApi.ApiSettings,
        ) {

        }

        public getData() {
            this.isLoading = true;
            this.restfullApiClientService.get('/client')
                .then((updatedClientData) => {
                    this.clientData = (updatedClientData as any).data.value;
                    this.loadLogoImage();
                })
                .finally(() => {
                    this.isLoading = false;
                })
        }

        private loadLogoImage() {
            if (!this.clientData || !this.clientData.clientCustomLogoUrl) {
                this.logoDisplayUrl = null;
                return;
            }

            // Fetch logo via $http to include auth headers, then create a blob URL
            this.$http({
                method: 'GET',
                url: '/api/v' + this.apiSettings.version + '/client/logo',
                responseType: 'blob'
            }).then((response: any) => {
                var blob = response.data;
                if (this.logoDisplayUrl) {
                    URL.revokeObjectURL(this.logoDisplayUrl);
                }
                this.logoDisplayUrl = URL.createObjectURL(blob);
            }, () => {
                this.logoDisplayUrl = null;
            });
        }

        public enableClient() {
            this.isLoading = true;
            this.restfullApiClientService.post('/client/enable', null)
                .then((updatedClientData) => {
                    this.clientData = (updatedClientData as any).data.value;
                    (this.$scope.$parent as IAppLayoutControllerScope).reloadClientInfo()
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }

        public disableClient() {
            this.isLoading = true;
            this.restfullApiClientService.post('/client/disable', null).then((updatedClientData) => {
                this.clientData = (updatedClientData as any).data.value;
                (this.$scope.$parent as IAppLayoutControllerScope).reloadClientInfo()
            })
                .finally(() => {
                    this.isLoading = false;
                });

        }

        public selectLogoFile() {
            var fileInput = document.getElementById('logoFileInput') as HTMLInputElement;
            if (fileInput) {
                fileInput.value = '';
                fileInput.click();
            }
        }

        public onLogoFileSelected(files: FileList) {
            if (!files || files.length === 0) {
                return;
            }

            var file = files[0];

            // Validate file type
            var allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/webp'];
            if (allowedTypes.indexOf(file.type) === -1) {
                alert('Invalid file type. Please select an image file (JPG, PNG, GIF, SVG, or WebP).');
                return;
            }

            // Validate file size (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                alert('File is too large. Maximum size is 5 MB.');
                return;
            }

            this.uploadLogo(file);
        }

        private uploadLogo(file: File) {
            this.isUploadingLogo = true;
            this.$scope.$apply();

            var formData = new FormData();
            formData.append('file', file);

            var uploadUrl = '/api/v' + this.apiSettings.version + '/client/logo';

            this.$http({
                method: 'POST',
                url: uploadUrl,
                data: formData,
                headers: {
                    'Content-Type': undefined // Let browser set multipart boundary
                },
                transformRequest: angular.identity
            }).then((response: any) => {
                this.clientData = response.data.value || response.data;
                this.loadLogoImage();
                (this.$scope.$parent as IAppLayoutControllerScope).reloadClientInfo();
            }, (error) => {
                var message = (error.data && error.data.message) ? error.data.message : 'Failed to upload logo. Please try again.';
                alert(message);
            }).finally(() => {
                this.isUploadingLogo = false;
            });
        }

        async $onInit() {

        }

        async $onChanges() {
            this.getData();
        }
    }
    angular.module('fdm.clientManagement').component('clientManagementDetails', {
        bindings: {
            queryResult: '<'
        },
        controller: ClientManagementDetailsController,
        templateUrl: '/app/src/client-management/client-management-details.html'
    });
}